import Hero from "../Hero";
import {useRouter} from "next/router";
import localized from "../../locale/locales";
import Title from "../Title";

export default function SectionLooksGood({imageDesktop, imageMobile = imageDesktop}) {
    const {locale} = useRouter();
    const {sections: {looksGood: lang}} = localized[locale];

    return (
        <Hero direction="image-right"
              imageDesktop={imageDesktop}
              imageMobile={imageMobile}
              className="relative items-center gap-10">
            <div className="flex flex-col gap-5 accent-purple-800">
                <header>
                    <Title className="max-w-[15ch]">{lang.title.localize()}</Title>
                </header>
                <div className="flex flex-col gap-8">
                    <p className="leading-[1.8] max-w-[46ch]">
                        {lang.body}
                    </p>
                </div>
            </div>
        </Hero>
    )
}